/** Make a string out of an error (or other equivalents), including any additional data such as stack trace if available */
export function stringifyError(error, noStack = false) {
    let str = undefined;
    if (error && typeof error === 'object') {
        if (Array.isArray(error)) {
            return error.map((e) => stringifyError(e, noStack)).join(', ');
        }
        if (error.toString && error.toString !== Object.prototype.toString) {
            // Has a custom toString() method
            str = `${error.toString()}`;
        }
        else {
            const strings = [
                stringify(error.message), // Error
                stringify(error.details),
            ];
            str = strings.filter(Boolean).join(', ');
        }
        if (!str) {
            try {
                // Try to stringify the object:
                str = JSON.stringify(error);
            }
            catch (e) {
                str = `${error} (stringifyError: ${e})`;
            }
        }
        // Is an instance of a class (like KeyboardEvent):
        const instanceName = error.constructor?.name;
        if (instanceName && instanceName !== 'Object' && instanceName !== 'Array')
            str = `${instanceName}: ${str}`;
    }
    else {
        str = `${error}`;
    }
    if (!noStack) {
        if (error && typeof error === 'object' && typeof error.stack === 'string') {
            str += ', ' + error.stack;
        }
    }
    if (str.startsWith('Error: '))
        str = str.slice('Error: '.length);
    return str;
}
function stringify(v) {
    // Tries to stringify objects if they have a toString() that returns something sensible
    if (v === undefined)
        return undefined;
    if (v === null)
        return 'null';
    if (typeof v === 'object') {
        const str = `${v}`;
        if (str !== '[object Object]')
            return str;
        return undefined;
    }
    else
        return `${v}`;
}
//# sourceMappingURL=Stringify.js.map